import { QueryKeys } from "@/lib/query-keys";
import { apiPatch } from "../client";
import type { IUpdateExamAssignmentInput } from "./types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export async function updateExamAssignment(
  id: string,
  input: IUpdateExamAssignmentInput
) {
  const response = await apiPatch<{ message: string }>(
    `/exam_assignments/${id}`,
    input
  );
  return response.data;
}

export function useUpdateExamAssignment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      input,
    }: {
      id: string;
      input: IUpdateExamAssignmentInput;
    }) => updateExamAssignment(id, input),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: QueryKeys.examAssignment.all });
      queryClient.invalidateQueries({
        queryKey: QueryKeys.examAssignment.monitor(variables.id),
      });
    },
  });
}
